<template>
  <div>
    <label class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack mb-2">
      <span @click="labelAction_($event)" class="form-check-label ms-0 fw-bolder fs-6" :class="{'text-gray-700': !labelAction, 'text-primary': labelAction}">{{ label }}</span>
      
    </label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String|Number,
      required: true,
    },
    labelAction: {
      default: false,
    },
  },
  methods: {
    labelAction_(e){
      if(!this.labelAction) return;
      e.preventDefault()
      this.labelAction()
    },
  },
}
</script>